/**
 * Page operation type
 */
export enum PageActionType {
	ADD = 0,
	UPDATE = 1,
	CHECK = 2,
	BATCH = 3,
}
